import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
// Customizable Area Start
import { ILoyalty } from "./LoyaltyListController.web";
import React from "react";
import _ from "lodash";
import { getStorageData } from "../../../framework/src/Utilities";
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import {
  PermissionStatus,
  checkForNewPermissonStatus,
  customPermissionApiKey
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import { updateMultiSelectData } from "../../../components/src/common";

export interface IExpiryDate {
  id: string;
  type: string;
  attributes: {
    expiry_date: string;
  };
}

export const configJSON = require("./config");

export interface Props {
  navigation: {
    navigate: (routeName: string) => void;
    goBack: () => void;
    history: {
      push: (path: string) => void;
    };
  };
  id: string;
}

type SectionOption = {
  id: string
  option: string
}

type DropdownOption = {
  id: string | number
  option: string
}

interface S {
  loyalty: ILoyalty;
  initialLoyalty: ILoyalty;
  loyaltyId: string;
  formErrors: { [key: string]: string };
  expiryDateList: IExpiryDate[];
  sectionList: SectionOption[];
  selectedSections: SectionOption[];
  selectedSectionsForList: SectionOption[];
  isSectionSelectAll: boolean;
  sectionPage: number;
  sectionSearchText: string;
  snackBarMessage: string;
  permissionStatus: PermissionStatus;
  isLoadingPermission: boolean;
  // Region
  regionList: DropdownOption[];
  regionSelectedData: DropdownOption[];
  selectedRegionsForList: DropdownOption[];
  isRegionSelectAll: boolean;
  // Area
  areaList: DropdownOption[];
  areaSelectedData: DropdownOption[];
  selectedAreasForList: DropdownOption[];
  isAreaSelectAll: boolean;
  // Store
  storeList: DropdownOption[];
  selectedStore: DropdownOption[];
  storeSelectedOptionForList: DropdownOption[];
  isStoreSelectAll: boolean;
}

interface SS {
  id: number | string;
}

const emptyLoyalty: ILoyalty = {
  id: "",
  type: "reward",
  attributes: {
    active: false,
    expiry_date: "",
    all_section_enabled: false,
    sections: [],
  },
};

export default class AddLoyaltyController extends BlockComponent<Props, S, SS> {
  itemsPerPage = 10;
  updateLoyaltyCallId: string = "";
  addLoyaltyCallId: string = "";
  getLoyaltyCallId: string = "";
  expiryListCallId: string = "";
  sectionListCallId: string = "";
  regionListCallId: string = "";
  areaListCallId: string = "";
  storeListCallId: string = "";
  disableLoadMoreSection = false;

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.LayoutDataMessage),
    ];

    this.state = {
      loyalty: {
        ...emptyLoyalty,
      },
      initialLoyalty: {
        ...emptyLoyalty,
      },
      loyaltyId: "",
      formErrors: {},
      snackBarMessage: "",
      expiryDateList: [],
      sectionList: [],
      selectedSections: [],
      selectedSectionsForList: [],
      sectionPage: 1,
      sectionSearchText: '',
      isSectionSelectAll: false,
      permissionStatus: {
        mainPermission: false,
        createPermission: false,
        viewPermission: false,
        editPermission: false,
        deactivatePermission: false
      },
      isLoadingPermission: true,
      // Region
      regionList: [],
      regionSelectedData: [],
      selectedRegionsForList: [],
      isRegionSelectAll: false,
      // Area
      areaList: [],
      areaSelectedData: [],
      selectedAreasForList: [],
      isAreaSelectAll: false,
      // Store
      storeList: [],
      selectedStore: [],
      storeSelectedOptionForList: [],
      isStoreSelectAll: false,
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  receiveUpdateLoyalty = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson) {
      if (responseJson.data.attributes && responseJson.data.attributes.errors) {
        const errors = responseJson.data.attributes.errors;
        if (errors.sections) {
          this.setState({
            formErrors: {
              ...this.state.formErrors,
              sections: errors.sections[0],
            },
          });
        }
      } else {
        if (this.state.loyaltyId)
          this.showMessage("Loyalty Updated Successfully");
        else this.showMessage("Loyalty Added Successfully");
        setTimeout(() => {
          this.props.navigation.goBack();
        }, 2000);
      }
    }
  };

  receiveGetLoyalty = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson) {
      const { all_section_enabled = false, sections = [], regions = [], areas = [], stores = [] } = responseJson.data?.attributes || {}
      const currentSelectedSections = sections.map((section: {id: number; name: string}) => ({id: section.id.toString(), option: section.name}))

      const currentSelectedRegions = regions.map((r: { id: number; branch_name: string }) => ({ id: r.id.toString(), option: r.branch_name }))
      const currentSelectedAreas = areas.map((a: { id: number; area_name: string }) => ({ id: a.id.toString(), option: a.area_name }))
      const currentSelectedStores = stores.map((s: { id: number; store_name: string }) => ({ id: s.id.toString(), option: s.store_name }))

      this.setState({
        loyalty: responseJson.data,
        initialLoyalty: responseJson.data,
        isSectionSelectAll: all_section_enabled,
        sectionList: currentSelectedSections,
        selectedSections: all_section_enabled ? [{ id: "-1", option: "Select All" }] : currentSelectedSections,
        selectedSectionsForList: all_section_enabled ? [{ id: "-1", option: "Select All" },... currentSelectedSections] : currentSelectedSections,
        // Region
        regionSelectedData: currentSelectedRegions,
        selectedRegionsForList: currentSelectedRegions,
        // Area
        areaSelectedData: currentSelectedAreas,
        selectedAreasForList: currentSelectedAreas,
        // Store
        selectedStore: currentSelectedStores,
        storeSelectedOptionForList: currentSelectedStores,
      }, () => {
        this.getSectionList();
        this.getRegionList();
        if (currentSelectedRegions.length > 0) {
          const regionQuery = currentSelectedRegions.map((r: DropdownOption) => `&region_id[]=${r.id}`).join("");
          this.getAreaList(regionQuery);
        }
        if (currentSelectedAreas.length > 0) {
          const areaQuery = currentSelectedAreas.map((a: DropdownOption) => `&area_id[]=${a.id}`).join("");
          this.getStoreList(areaQuery);
        }
      });
    }
  };

  receiveSectionResponse = (responseJson : {data?: {id: string; attributes: {section_name: string}}[]}) => {
    const sectionListData  = responseJson.data || []
          const receivedSections = sectionListData.map(sectionItem => ({id: sectionItem.id, option: sectionItem.attributes.section_name}))
          this.disableLoadMoreSection = receivedSections.length < this.itemsPerPage
          const currentSelectedSections = this.state.selectedSectionsForList.filter(item => item.id !== "-1")
          this.setState({
              sectionList: _.uniqBy([...(this.state.sectionPage === 1 ? currentSelectedSections 
                  : this.state.sectionList), ...receivedSections],"id"),
              selectedSectionsForList: this.state.isSectionSelectAll ? 
                  _.uniqBy([
                      ...this.state.selectedSectionsForList,
                      ...receivedSections
                  ], "id") : this.state.selectedSectionsForList,
          })
  }

  async receive(from: string, message: Message) {
    this.receiveDataFromLayout(message);
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (apiRequestCallId === this.expiryListCallId) {
        if (responseJson) {
          this.setState({ expiryDateList: responseJson.data });
        }
      } else if (apiRequestCallId === this.sectionListCallId) {
        if (responseJson) {
          this.receiveSectionResponse(responseJson)
        }
      } else if (apiRequestCallId === this.regionListCallId) {
        if (responseJson?.data) {
          const regions = responseJson.data.map((item: { id: string; attributes: { name: string; region_name?: string } }) => ({
            id: item.id,
            option: item.attributes?.name || item.attributes?.region_name || ""
          }));
          this.setState({ regionList: regions });
        }
      } else if (apiRequestCallId === this.areaListCallId) {
        if (responseJson?.data) {
          const areas = responseJson.data.map((item: { id: string; attributes: { name: string; area_name?: string } }) => ({
            id: item.id,
            option: item.attributes?.name || item.attributes?.area_name || ""
          }));
          this.setState({ areaList: areas });
        }
      } else if (apiRequestCallId === this.storeListCallId) {
        if (responseJson?.data) {
          const stores = responseJson.data.map((item: { id: string; attributes: { store_name: string } }) => ({
            id: item.id,
            option: item.attributes?.store_name || ""
          }));
          this.setState({ storeList: stores });
        }
      } else if (apiRequestCallId === this.updateLoyaltyCallId) {
        this.receiveUpdateLoyalty(message);
      } else if (apiRequestCallId === this.getLoyaltyCallId) {
        this.receiveGetLoyalty(message);
      }
    }
  }

  receiveDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
        const recievedData = message.getData(
            getName(MessageEnum.LayoutMessageData)
        );
        if (recievedData.userContext) {
            this.handleUserChange(recievedData.userContext)
        }
    }
  }
  
  getExpiryList = async () => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.expiryListCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.expiryListApi
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };
  getSectionList =async () => {
    const headerSection = {
      "Content-Type": configJSON.contentType,
      token: await getStorageData(configJSON.tokenKey),
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.sectionListCallId = getDataMsg.messageId;
    this.disableLoadMoreSection = true;
    const searchQuery = this.state.sectionSearchText ? `&filter_by[query]=${this.state.sectionSearchText}` : ''
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerSection)
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.sectionListApi}${searchQuery}&page_no=${this.state.sectionPage}&per_page=${this.itemsPerPage}`
    );
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");

    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getLoyalty = async (loyaltyId: string) => {
    const header = {
      "Content-Type": configJSON.contentType,
      token: await getStorageData(configJSON.tokenKey),
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getLoyaltyCallId = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getMethod
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.loyaltyListApi + "/" + loyaltyId
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  updateCreateLoyaltyInfo = async () => {
    const header = {
      "Content-Type": configJSON.contentType,
      token: await getStorageData(configJSON.tokenKey),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.updateLoyaltyCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.loyaltyListApi}` +
        (this.state.loyaltyId ? `/${this.state.loyaltyId}` : "")
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    const expiry = this.state.expiryDateList.find(
      (expiryDate) =>
        expiryDate.attributes.expiry_date ===
        this.state.loyalty.attributes.expiry_date
    );
    const datas = {
      active: this.state.loyalty.attributes.active,
      spend_amount: this.state.loyalty.attributes.spend_amount,
      earned_points: this.state.loyalty.attributes.earned_points,
      redeemed_points: this.state.loyalty.attributes.redeemed_points,
      received_amount: this.state.loyalty.attributes.received_amount,
      min_redeemed_points: this.state.loyalty.attributes.min_redeemed_points,
      expiry_id: expiry ? parseInt(expiry.id) : "",
      all_section_enabled: this.state.isSectionSelectAll ? true : undefined,
      section_ids: this.state.selectedSectionsForList.filter(item => item.id !== "-1").map(section => Number(section.id)),
      region_ids: this.state.selectedRegionsForList.filter(item => item.id !== "-1").map(r => Number(r.id)),
      area_ids: this.state.selectedAreasForList.filter(item => item.id !== "-1").map(a => Number(a.id)),
      store_ids: this.state.storeSelectedOptionForList.filter(item => item.id !== "-1").map(s => Number(s.id)),
    };

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({ data:datas })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      this.state.loyaltyId ? configJSON.putMethod : configJSON.postMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  // web events

  onCancel = () => {
    this.setState({ loyalty: { ...this.state.initialLoyalty } });
    this.props.navigation.goBack();
  };

  checkFormErrors = () => {
    const { loyalty, selectedSections, isSectionSelectAll } = this.state;
    const { attributes } = loyalty;
    const {
      expiry_date,
      spend_amount,
      earned_points,
      received_amount,
      redeemed_points,
      min_redeemed_points,
    } = attributes;
    const formErrors: { [key: string]: string } = {};
    if (!expiry_date)
      formErrors["expiry_date"] = "Expiry date name is required";
    if (spend_amount === undefined)
      formErrors["spend_amount"] = "Spend amount is required";
    if (earned_points === undefined)
      formErrors["earned_points"] = "Earned points is required";
    if (received_amount === undefined)
      formErrors["received_amount"] = "Credit amount is required";
    if (redeemed_points === undefined)
      formErrors["redeemed_points"] = "Used points is required";
    if (min_redeemed_points === undefined)
      formErrors["min_redeemed_points"] = "Minimum Redeem points is required";
    if (!selectedSections.length && !isSectionSelectAll)
      formErrors["sections"] = "Section is required";
    this.setState({ formErrors });
    return Object.keys(formErrors).length === 0;
  };

  onSave = () => {
    if (this.checkFormErrors()) {
      this.updateCreateLoyaltyInfo();
    }
  };

  goBack = () => {
    this.props.navigation.goBack();
  };

  async componentDidMount() {
    super.componentDidMount();
    this.getExpiryList();
    this.getRegionList();
    const loyaltyId = window.location.search.split("=")[1];
    if (loyaltyId) {
      this.getLoyalty(loyaltyId);
      this.setState({ loyaltyId: loyaltyId });
    } else {
      this.getSectionList();
    }
  }

  showMessage = (message: string) => {
    this.setState({ snackBarMessage: message });
  };

  closeSnackBar = () => {
    this.setState({ snackBarMessage: "" });
  };

  handleEdit = () => {
    const loyaltyId = this.state.loyaltyId;
    window.localStorage.setItem("loyaltyId", loyaltyId);
    this.props.navigation.history.push("Marketing-LoyaltyList-EditLoyalty?loyaltyId=" + loyaltyId);
  };

  handleCheckedChange = (checked: boolean) => {
    this.setState({
      loyalty: {
        ...this.state.loyalty,
        attributes: {
          ...this.state.loyalty.attributes,
          active: checked,
        },
      },
    });
  };

  handleSectionMultiSelect = (option: { id: string, option: string } ) => {
    const {selectedSectionsForList} = this.state
    let updateStateData: Partial<S> = {}
    if (option.id === "-1") {
      updateStateData =  this.state.isSectionSelectAll ?
      { isSectionSelectAll: false, selectedSections: [], selectedSectionsForList: [] }
      :
      {
        isSectionSelectAll: true,
        selectedSections: [{ id: "-1", option: "Select All" }],
        selectedSectionsForList: [{ id: "-1", option: "Select All" }, ...this.state.sectionList]
      }
    } else {
      const isValueContained = selectedSectionsForList.some((item) => item.id == option.id)
      const selectedSectionOptions = selectedSectionsForList.filter((item) => item.id !== "-1")
      const newSelectedSections = isValueContained ? selectedSectionOptions.filter((item) => item.id != option.id) : [...selectedSectionOptions, option]
      updateStateData = updateMultiSelectData(newSelectedSections, this.state.sectionList, 'isSectionSelectAll', 'selectedSections', 'selectedSectionsForList')
    }
    this.setState({isSectionSelectAll: updateStateData.isSectionSelectAll as boolean, selectedSections: updateStateData.selectedSections as SectionOption[], selectedSectionsForList: updateStateData.selectedSectionsForList as SectionOption[]})
  };

  debouncedFunction = _.debounce(
    (newInputValue: string) => this.handleSectionAutoCompleteChange(newInputValue),
        700,
        { maxWait: 2000 }
  );
  handleSectionAutoCompleteChange = (getValue: string) => {
    if (getValue === this.state.sectionSearchText) return;
    this.setState({ sectionSearchText: getValue, sectionPage: 1 }, () => {
        if (getValue.length < 1 || getValue.length > 2) {
        this.getSectionList()
        }
    });
  }

  handleScrollSectionDropdown = (event: React.SyntheticEvent) => {
    if (this.disableLoadMoreSection) return;
    const checkListboxNode = event.currentTarget;
    const boxPosition = checkListboxNode.scrollTop + checkListboxNode.clientHeight;

    if (checkListboxNode.scrollHeight - boxPosition <= 1.30) {
      this.setState((prevState) => ({ sectionPage: prevState.sectionPage + 1 }), () => {
        this.getSectionList()
      })
    }
  };

  handleExpiryDateChange = (
    event: React.ChangeEvent<{
      name?: string;
      value: unknown;
    }>
  ) => {
    this.setState({
      loyalty: {
        ...this.state.loyalty,
        attributes: {
          ...this.state.loyalty.attributes,
          expiry_date: event.target.value as string,
        },
      },
    });
  };

  handleUserChange = (userContext: IUserContext) => {
    const apiKey = customPermissionApiKey.loyaltySystem;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForNewPermissonStatus(apiKey, userData as Array<PermissionGroupArray>);
    this.setState({
      permissionStatus: value,
      isLoadingPermission: false
    })
  };

  numericInputChange = (event: React.ChangeEvent<HTMLInputElement>, keys: string) => {
    this.setState((prevState) => ({
      loyalty: {
        ...prevState.loyalty,
        attributes: {
          ...prevState.loyalty.attributes,
          [keys]: event.target.value ? parseFloat(event.target.value) : "",
        },
      },
    }));
  };

  numericKeyPress = (event: React.KeyboardEvent) => {
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  };

  // Region / Area / Store API calls
  getRegionList = async () => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.regionListCallId = getDataMsg.messageId;
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.regionListApi);
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getAreaList = async (queryParam: string) => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.areaListCallId = getDataMsg.messageId;
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.areaListApi + queryParam);
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getStoreList = async (queryParam: string) => {
    const token = await getStorageData(configJSON.tokenKey);
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.storeListCallId = getDataMsg.messageId;
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.storeListApi + token + queryParam);
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  // Region multi-select handler
  handleRegionMultiSelect = (value: DropdownOption[], option: DropdownOption) => {
    const { selectedRegionsForList } = this.state;
    let updateStateData: Partial<S> = {};
    if (option.id === "-1") {
      updateStateData = this.state.isRegionSelectAll
        ? { isRegionSelectAll: false, regionSelectedData: [], selectedRegionsForList: [] }
        : {
            isRegionSelectAll: true,
            regionSelectedData: [{ id: "-1", option: "Select All" }],
            selectedRegionsForList: [{ id: "-1", option: "Select All" }, ...this.state.regionList],
          };
    } else {
      const isValueContained = selectedRegionsForList.some((item) => item.id == option.id);
      const selectedOptions = selectedRegionsForList.filter((item) => item.id !== "-1");
      const newSelected = isValueContained ? selectedOptions.filter((item) => item.id != option.id) : [...selectedOptions, option];
      updateStateData = updateMultiSelectData(newSelected, this.state.regionList, "isRegionSelectAll", "regionSelectedData", "selectedRegionsForList");
    }
    this.setState(
      {
        isRegionSelectAll: updateStateData.isRegionSelectAll as boolean,
        regionSelectedData: updateStateData.regionSelectedData as DropdownOption[],
        selectedRegionsForList: updateStateData.selectedRegionsForList as DropdownOption[],
      },
      () => this.onChangeRegion()
    );
  };

  onChangeRegion = () => {
    // Clear area and store selections when region changes
    this.setState({
      areaSelectedData: [],
      selectedAreasForList: [],
      isAreaSelectAll: false,
      selectedStore: [],
      storeSelectedOptionForList: [],
      isStoreSelectAll: false,
      areaList: [],
      storeList: [],
    });
    const regionIds = this.state.selectedRegionsForList.filter((item) => item.id !== "-1");
    if (regionIds.length > 0) {
      const queryString = regionIds.map((r) => `&region_id[]=${r.id}`).join("");
      this.getAreaList(queryString);
    }
  };

  // Area multi-select handler
  handleAreaMultiSelect = (value: DropdownOption[], option: DropdownOption) => {
    const { selectedAreasForList } = this.state;
    let updateStateData: Partial<S> = {};
    if (option.id === "-1") {
      updateStateData = this.state.isAreaSelectAll
        ? { isAreaSelectAll: false, areaSelectedData: [], selectedAreasForList: [] }
        : {
            isAreaSelectAll: true,
            areaSelectedData: [{ id: "-1", option: "Select All" }],
            selectedAreasForList: [{ id: "-1", option: "Select All" }, ...this.state.areaList],
          };
    } else {
      const isValueContained = selectedAreasForList.some((item) => item.id == option.id);
      const selectedOptions = selectedAreasForList.filter((item) => item.id !== "-1");
      const newSelected = isValueContained ? selectedOptions.filter((item) => item.id != option.id) : [...selectedOptions, option];
      updateStateData = updateMultiSelectData(newSelected, this.state.areaList, "isAreaSelectAll", "areaSelectedData", "selectedAreasForList");
    }
    this.setState(
      {
        isAreaSelectAll: updateStateData.isAreaSelectAll as boolean,
        areaSelectedData: updateStateData.areaSelectedData as DropdownOption[],
        selectedAreasForList: updateStateData.selectedAreasForList as DropdownOption[],
      },
      () => this.onChangeArea()
    );
  };

  onChangeArea = () => {
    // Clear store selections when area changes
    this.setState({
      selectedStore: [],
      storeSelectedOptionForList: [],
      isStoreSelectAll: false,
      storeList: [],
    });
    const areaIds = this.state.selectedAreasForList.filter((item) => item.id !== "-1");
    if (areaIds.length > 0) {
      const queryString = areaIds.map((a) => `&area_id[]=${a.id}`).join("");
      this.getStoreList(queryString);
    }
  };

  // Store multi-select handler
  handleStoreMultiSelect = (value: DropdownOption[], option: DropdownOption) => {
    const { storeSelectedOptionForList } = this.state;
    let updateStateData: Partial<S> = {};
    if (option.id === "-1") {
      updateStateData = this.state.isStoreSelectAll
        ? { isStoreSelectAll: false, selectedStore: [], storeSelectedOptionForList: [] }
        : {
            isStoreSelectAll: true,
            selectedStore: [{ id: "-1", option: "Select All" }],
            storeSelectedOptionForList: [{ id: "-1", option: "Select All" }, ...this.state.storeList],
          };
    } else {
      const isValueContained = storeSelectedOptionForList.some((item) => item.id == option.id);
      const selectedOptions = storeSelectedOptionForList.filter((item) => item.id !== "-1");
      const newSelected = isValueContained ? selectedOptions.filter((item) => item.id != option.id) : [...selectedOptions, option];
      updateStateData = updateMultiSelectData(newSelected, this.state.storeList, "isStoreSelectAll", "selectedStore", "storeSelectedOptionForList");
    }
    this.setState({
      isStoreSelectAll: updateStateData.isStoreSelectAll as boolean,
      selectedStore: updateStateData.selectedStore as DropdownOption[],
      storeSelectedOptionForList: updateStateData.storeSelectedOptionForList as DropdownOption[],
    });
  };

  handleClearMultiSelect = (fieldName: string) => {
    if (fieldName === "region") {
      this.setState({ regionSelectedData: [], selectedRegionsForList: [], areaList: [], isRegionSelectAll: false });
    }
    if (fieldName === "area" || fieldName === "region") {
      this.setState({ areaSelectedData: [], selectedAreasForList: [], isAreaSelectAll: false });
    }
    if (fieldName === "store" || fieldName === "area" || fieldName === "region") {
      this.setState({ selectedStore: [], storeSelectedOptionForList: [], storeList: [], isStoreSelectAll: false });
    }
  };

  // Customizable Area End
}
